import Headroom from 'headroom.js';

export default function initHeadroom() {
	const header = document.querySelector('header.wp-block-template-part');
	if (!header) {
		return;
	}

	const headroom = new Headroom(header, {
		offset: { up: 100, down: 50 },
		tolerance: { up: 5, down: 0 },
	});
	headroom.init();
}
